<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <slot name="activator"></slot>
      </div>
    </template>
    <v-time-picker
      v-if="menu"
      v-model="time"
      :min="params.min"
      :max="params.max"
      full-width
      format="24hr"
      color="switchq"
      @click:minute="$refs.menu.save(time)"
    >
      <v-spacer></v-spacer>
      <v-btn block color="switchq" class="white--text" @click="menu = false">
        {{ $t("confirm") }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-time-picker>
  </v-menu>
</template>
<script>
export default {
  name: "TimePickerMenu",
  props: ["value", "min", "max"],
  emits: ["input"],
  data() {
    return {
      time: null,
      menu: false,
      params: {
        min: "00:00",
        max: "23:59",
      },
    };
  },
  mounted() {
    this.time = this.initialTimeValue;
  },
  computed: {
    initialTimeValue() {
      return this.numToTime(this.value);
    },
  },
  watch: {
    initialTimeValue(newTime) {
      this.time = newTime;
    },
    menu(menu) {
      if (!menu) {
        this.$emit("input", this.timeToNum(this.time));
      } else {
        if (this.min) this.params.min = this.numToTime(this.min);
        if (this.max) this.params.max = this.numToTime(this.max);
      }
    },
  },
  methods: {
    numToTime(totalMinutes) {
      let time = parseInt(totalMinutes);
      const hours = time >= 60 ? Math.floor(time / 60) : 0;
      const minutes = totalMinutes - hours * 60;
      const result = [
        String(hours).padStart(2, "0"),
        String(minutes).padStart(2, "0"),
      ].join(":");
      return result;
    },
    timeToNum(time) {
      let totalMinutes = time.split(":").map((n) => parseInt(n));
      totalMinutes = totalMinutes[0] * 60 + totalMinutes[1];
      return totalMinutes;
    },
  },
};
</script>
<style lang="scss">
// #
</style>
